<template>
  <div v-show="!isSSOEnabledWebsite">
    <div class="row h-100">
      <div
        class="bg-white col-md-8"
        v-bind:class="{
          'mx-auto': hideRightPanel,
        }"
      >
      <div class="p-5 mx-auto" style="max-width:500px;">
        <h3 class="logo">
          <a class="no-underline" :href="homepage">
            <img id="logo-img" :src="$customdomain().logo" width="120px" />
          </a>
        </h3>

        <div v-if="successMsg" class="alert alert-success" role="alert">
          {{ successMsg }}
        </div>

        <div v-if="errorMsg" class="alert alert-danger" role="alert">
          {{ errorMsg }}
        </div>

        <form id="form" class="mt-4 pt-2" @submit.prevent="loginValidate">
          <h3 class="pb-3 font-weight-bolder" v-translate v-if="!headlines">
            {{ t('Welcome back!') }}
          </h3>
          <h3 class="pb-3" v-else>
            {{ t(headlines) }}
          </h3>

          <template v-if="$isHowuku">
            <a
              @click="googlePopup"
              class="btn btn-outline fw-400 d-block"
              href="#"
              role="button"
              style="text-transform: none"
            >
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48" style="margin-right: 5px; vertical-align: middle;">
                <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
              </svg>            
              Sign in with Google
            </a>

            <!-- <a
              @click="githubPopup"
              class="btn btn-outline fw-400 d-block mt-2"
              href="#"
              role="button"
              style="text-transform: none"
            >
              <img
                width="20px"
                style="margin-bottom: 3px; margin-right: 5px"
                class="fw-500"
                alt="Google sign-in"
                src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
              />
              Sign in with Github
            </a>             -->

            <div class="or-login my-4">
              <span class="bg-white">or log in with email</span>
            </div>            
          </template>

          <div class="form-group text-left" v-bind:class="{ 'd-none': showSSOOnly }">
            <label class="font-weight-bold" v-translate>Email</label>
            <input
              type="email"
              v-model="email"
              @keyup.enter="submit()"
              v-bind:keyup="(uIsBlank = false)"
              required="required"
              @keyup.delete="emailBlank"
              v-bind:class="{ blank: uIsBlank }"
              class="form-control"
              id="email"
              aria-describedby="emailHelp"
              placeholder="Enter your email"
            />
            <small class="text-danger" v-if="uIsBlank" v-translate
              >Please enter your email address</small
            >
          </div>
          <div class="form-group text-left" v-bind:class="{ 'd-none': showSSOOnly }">
            <label class="font-weight-bold" v-translate>Password</label>
            <input
              type="password"
              v-model="password"
              @keyup.enter="submit()"
              v-bind:keyup="(pIsBlank = false)"
              required="required"
              @keyup.delete="passwordBlank"
              v-bind:class="{ blank: pIsBlank }"
              class="form-control"
              id="exampleInputPassword1"
              placeholder="Enter your password"
            />
            <small class="text-danger" v-if="pIsBlank" v-translate
              >Please enter your login password</small
            >

            <p id="email" class="form-text text-muted mt-3">
              <router-link
                tag="a"
                to="/forgot-password"
                class="text-first a-link"
                >{{ t('I forgot my password') }}</router-link
              >
            </p>
          </div>
          <br />
          <input
            type="submit"
            class="btn btn-first btn-block px-4 d-block"
            v-if="!isSubmitted"
            v-bind:class="{ 'd-none': showSSOOnly }"
            :value="t('Log in')"
          />
          <button v-else-if="isSubmitted" class="btn btn-first btn-block px-4 d-block disabled"><font-awesome-icon icon="circle-notch" class="fa-spin text-muted fa-sm mr-2" /> {{ t('Logging in...') }}</button>

          <template v-if="isSSOForceRedirect">
            <!-- <span
              class="mx-3"
              v-translate
              v-bind:class="{ 'd-none': showSSOOnly }"
              >OR</span
            > -->
            <span
              @submit.prevent
              @click="auth0Login"
              class="btn btn-firstary btn-block px-4"
              v-bind:class="{ 'd-block': showSSOOnly }"
            >
              <span style="font-weight: 500; font-size: 14px" v-translate
                >Log in via SSO</span
              >
            </span>
          </template>

          <p v-if="$isHowuku || isNewWhiteLabel" class="mt-4">
            {{ t("Don't have an account yet?") }}
            <router-link tag="a" to="/sign-up" class="text-first a-link">{{
              t('Sign up for free')
            }}</router-link>
          </p>          
        </form>
      </div>
      </div>
      <div class="col-md-4 p-5" v-if="!hideRightPanel">
        <img class="img-fluid px-4" src="../assets/img/happy-customer.svg" />
        <h2 class="mt-3 pt-3" v-translate>Website personalization</h2>
        <p class="text-muted mt-3" v-translate>
          Create a unique experience for every visitors to maximize website
          conversion rates.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import database from '@/service/firebase.service'
/* eslint-disable */
var axios = require('axios')
// var workemail = require('company-email-validator')

export default {
  watch: {
    '$auth.user': function (user) {
      if (this.isSSOEnabledWebsite) {
        if (user) {
          this.email = user.email
          this.name = user.name
          this.photo = user.picture
          setTimeout(() => {
            console.log('SSO Authenticated: ' + user.email)
            this.$session.set('isAuth0', true)
            this.socialLoginSuccess()
          }, 200)
        } else {
          this.$auth.loginWithRedirect()
        }
      }
    },
  },
  data: function () {
    return {
      homepage: this.$isMida ? 'https://mida.so' : this.$isHowuku ? 'https://howuku.com' : '/',
      name: '',
      photo: '',
      email: '',
      company: '',
      password: '',
      uIsBlank: false,
      pIsBlank: false,
      cIsBlank: false,
      failed: false,
      errorMsg: '',
      successMsg: '',
      isSubmitted: false,
      hideRightPanel: false,
      headlines: false,
      ssoInterval: null,
      isSSOForceRedirect: false,
      isSSOEnabledWebsite: true,
      showSSOOnly: false,
      isNewWhiteLabel: false
    }
  },
  created() {
    if (this.$isHowuku) this.isSSOEnabledWebsite = false

    if (window.location.host === 'demo.howuku.com') {
      this.$http
        .get(process.env.API_ENDPOINT + '/user/demo')
        .then((response) => {
          let info = response.data[0]
          this.authorize(info)
        })
        .catch(() => {})
    }
    this.hideRightPanel = !this.$isHowuku || this.$isMida

    let url = window.location.host
    let subdomain = url.replace('.howuku.com', '')
    if (!(subdomain === 'app')) {
      this.$http.get(process.env.API_ENDPOINT + '/domain/setting/' + subdomain)
        .then((result) => {
          if (result.data.length) {
            if (Number(result.data[0].paid_plan) === 104) {
              this.isNewWhiteLabel = true
            }
            if (result.data[0].sso_flag === 1) {
              if (result.data[0].sso_force_redirect === 1) {
                this.showSSOOnly = false
                this.isSSOForceRedirect = true
              } else {
                // show default login page
                this.isSSOEnabledWebsite = false
              }

              if (this.isSSOEnabledWebsite && !this.isSSOForceRedirect) {
                this.$router.push({ path: '/login' })
                this.isSSOEnabledWebsite = false
                this.showSSOOnly = false
                this.isSSOForceRedirect = true
              }

              // wait for 2 seconds for authentication before force redirection
              // this is to ensure soonest available time to login with authenticated sess
              // but not able to immediate redirect to login page
              this.SSOAuthenticate()
            } else {
              // show login page
              this.isSSOEnabledWebsite = false
            }

            this.$initTranslation().then(() => {
              this.$translate.setLang(result.data[0].custom_language)
            })
          }
        })
    }
  },
  beforeMount() {},
  mounted() {
    if (this.$route.query.email) this.email = this.$route.query.email
    if (this.$route.query.verify_id)
      this.emailVerifyLogin(this.$route.query.verify_id)
    let counter = 0
    let intervalImg = setInterval(() => {
      if (document.getElementById('logo-img')) {
        if (
          document.getElementById('logo-img').src &&
          document.getElementById('logo-img').src === ''
        )
          clearInterval(intervalImg)

        if (
          (document.getElementById('logo-img').src === '' ||
            !document.getElementById('logo-img').src) &&
          this.$customdomain().logo
        ) {
          document.getElementById('logo-img').src = this.$customdomain().logo
        }
      }

      // avoid endless loop
      if (counter > 50) clearInterval(intervalImg)
      counter++
    }, 100)

    if (window.error) {
      this.errorMsg = window.error
      window.error = null
      setTimeout(() => (this.errorMsg = ''), 20000)
    }

    if (window.success) {
      this.successMsg = window.success
      window.success = null
      setTimeout(() => (this.successMsg = ''), 60000)
    }

    setTimeout(() => {
      // if have session, login
      if (
        window.location.pathname.includes('shopify') &&
        this.$session.get('email') &&
        this.$session.get('company_id')
      ) {
        this.$router.push({
          path: this.$route.query.redirect
            ? this.$route.query.redirect
            : '/',
        })
      }
    }, 100)
  },
  methods: {
    emailVerifyLogin(id) {
      if (id === 'verified') {
        this.errorMsg = 'Your account has been verified. Please login manually.'
        return
      } else if (id === 'deleted') {
        //user.status === 2
        this.errorMsg = 'Your account cannot be used for now.'
        return
      }
      this.isSubmitted = true
      let data = { userId: id }
      this.$http
        .post(process.env.API_ENDPOINT + '/verified-email-auth', data)
        .then((response) => {
          let info = response.data[0]

          if (response.data.err) {
            this.failed = true
            this.errorMsg = response.data.err
            return true
          } else {
            if (data.localhost === 1) this.$session.set('bypass', true)
            return this.authorize(info)
          }
        })
        .then(loggedin => {
          setTimeout(() => {
            if (loggedin) this.isSubmitted = false
          }, 500)
        })
        .catch(() => {
          this.isSubmitted = false
        })
    },
    SSOAuthenticate() {
      console.log(this.$auth.user)

      setTimeout(() => {
        let user = this.$auth.user
        console.log(this.$auth.user)
        if (user) {
          this.email = user.email
          this.name = user.name
          this.photo = user.picture
          setTimeout(() => {
            console.log('SSO Authenticated: ' + user.email)
            this.$session.set('isAuth0', true)
            this.socialLoginSuccess()
          }, 200)
        } else if (!this.isSSOForceRedirect) {
          this.$router.push({ path: '/login' })
          this.isSSOEnabledWebsite = false
          this.showSSOOnly = false
          this.isSSOForceRedirect = true
        } else {
          this.$auth.loginWithRedirect()
        }
      }, 2000)
    },
    checkAuthentication() {
      let count = 0
      this.ssoInterval = setInterval(() => {
        let user = this.$auth.user
        if (user) {
          clearInterval(this.ssoInterval)
          this.email = user.email
          this.name = user.name
          this.photo = user.picture
          setTimeout(() => {
            console.log('SSO Authenticated: ' + user.email)
            this.$session.set('isAuth0', true)
            this.socialLoginSuccess()
          }, 100)
        }

        // stop trying after 3 seconds
        if (count > 30) {
          clearInterval(this.ssoInterval)
          if (this.isSSOForceRedirect) this.$auth.loginWithRedirect()
        }
        count++
      }, 100)
    },
    submit() {
      // document.getElementById("form").submit()
      this.loginValidate()
    },
    getCookie(a) {
      var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
      return b ? b.pop() : ''
    },
    emailBlank: function () {
      this.uIsBlank = false
      if (this.email == '') {
        this.uIsBlank = true
      }
    },
    passwordBlank: function () {
      this.pIsBlank = false
      if (this.password == '') {
        this.pIsBlank = true
      }
    },
    loginValidate: function () {
      if (!this.isSubmitted) {
        this.isSubmitted = true
        if (this.email === '') this.uIsBlank = true
        if (this.password === '') this.pIsBlank = true

        if (!this.uIsBlank && !this.pIsBlank) {
          this.authDB()
        } else {
          this.isSubmitted = false
        }
      }
    },
    auth0Login: function () {
      // this.$lock.show({
      //   callbackURL: 'https://api.howuku.com/sso/authenticate',
      // })
      this.$auth.loginWithRedirect()
    },
    authorize(info) {
      return new Promise((resolve, reject) => {
        localStorage.setItem('jwt', info.jwt)
        axios.defaults.headers.jwt = info.jwt
        this.$session.start()
        this.$session.set('name', info.name)
        this.$session.set('email', info.email)
        this.$session.set('email_hash', info.email_hash)
        this.$session.set('role', info.role)
        this.$session.set('widget_id', info.widget_id)
        this.$session.set('is_pageview', info.paid_plan_pageview > 0 ? 1 : 0)

        // bypassed login should only be viewer
        // if (this.$session.get('bypass')) this.$session.set('role', 3)

        this.$session.set('jwt', info.jwt)
        this.$session.set('session_time', +new Date())
        this.$session.set('user_id', info.user_id)
        this.$session.set('company_id', info.company_id)
        this.$session.set('company_name', info.company_name)
        this.$session.set('company_key', info.company_key)
        this.$session.set('new_user', info.new_user)
        this.$session.set('paid_plan', info.paid_plan)
        this.$session.set('version', info.version)
        this.$session.set('lifetimedeal', info.code !== '')
        this.$session.set('language', info.language)
        this.$session.set('whitelabel_ref_id', info.whitelabel_ref_id)

        window.HOWU_EMAIL = info.email

        if (!localStorage.getItem('jwt')) {
          console.error('No JWT localStorage' + localStorage.getItem('jwt'))
          this.$session.destroy()
          localStorage.removeItem('jwt')
          this.$router.push({ path: '/login' })
          resolve(true)
        } else {
          // not testing environment and not demo site
          let notTestEnvironment =
            !window.location.href.includes('localhost') &&
            !window.location.href.includes('demo.howuku.com') &&
            window.location.pathname !== '/hwlogin'
          
          let isOptimizeEnvironment = window.location.href.includes('optimize.howuku.com')

          if (notTestEnvironment) {
            try {
              this.$auditlog({
                module: 'user',
                action: 'login',
              })
            } catch (err) {}

            try {
              mida.identify('login_status', 'yes')
            } catch(e) {}

            try {
              import("company-email-validator").then((workemail) => {
                if (isOptimizeEnvironment) {
                _cio.identify({
                  id: info.email, // Use either id or email.
                  name: info.name,
                  company_email: workemail.isCompanyEmail(info.email),
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                  environment: "Optimize"
                })
              } else if (this.$isHowuku) {
                _cio.identify({
                  id: info.email, // Use either id or email.
                  name: info.name,
                  company_email: workemail.isCompanyEmail(info.email),
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                })
              }
              }).catch(error => console.log(error));
            } catch (err) {}
            try {
              if (mida){
                mida.identify({
                  email: info.email,
                  paid_plan: info.paid_plan,
                  name: info.name,
                  lifetime: info.code !== '' ? 'Y' : 'N',
                  login_status: 'yes'
                })
                .then(() => mida.track('Login', { email: info.email }))                
              } else if (window.howuku){
                window.howuku
                  .identify({
                    email: info.email,
                    paid_plan: info.paid_plan,
                    name: info.name,
                    lifetime: info.code !== '' ? 'Y' : 'N',
                  })
                  .then(() => window.howuku.track('Login', { email: info.email }))                
              }           
            } catch (err) {}
          }

          this.$router.push({
            path: this.$route.query.redirect
              ? this.$route.query.redirect
              : '/',
          })

          resolve(true)
        }
      })
    },
    googlePopup: function () {
      database.googleAuth().then((result) => {
      if (result.message) {
        // this.errorMsg = result.message
        // this.failed = true
        console.log(result.message)
      } else {
        this.email = result.email
        this.name = result.displayName
        this.photo = result.photoURL
        this.socialLoginSuccess()
      }
    })
    },
    githubPopup: function () {
      database.githubAuth().then((result) => {
      if (result.message) {
        // this.errorMsg = result.message
        // this.failed = true
        console.log(result.message)
      } else {
        this.email = result.email
        this.name = result.displayName
        this.photo = result.photoURL
        this.socialLoginSuccess()
      }
    })
    },    
    
    authDB: function () {
      let data = {
        email: this.email,
        password: this.password,
        domain: window.location.hostname,
      }

      if (
        (window.location.origin.includes('http://localhost:80') &&
          this.password === 'localhost') ||
        (window.location.pathname === '/hwlogin' &&
          this.password === 'localhost')
      ) {
        data.localhost = 1
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/authenticate', data)
        .then((response) => {
          let info = response.data[0]
          if (response.data.err) {
            this.failed = true
            this.errorMsg = response.data.err
            return true
          } else {
            if (data.localhost === 1) this.$session.set('bypass', true)
            return this.authorize(info)
          }
        })
        .then(loggedin => {
          setTimeout(() => {
            if (loggedin) this.isSubmitted = false
          }, 500)
        })
        .catch(() => {
          this.isSubmitted = false
        })
    },
    socialLoginSuccess: function () {
      this.$http
        .post(process.env.API_ENDPOINT + '/socialAuth', {
          name: this.name,
          photo: this.photo,
          email: this.email,
          company: this.company,
          ref: this.getCookie('_ak'),
          origin: window.location.host,
        })
        .then((response) => {
          let info = response.data[0]

          if (response.data.err) {
            this.failed = true
            this.errorMsg = response.data.err
            return
          } else if (info) {
            this.authorize(info)
          } else {
            this.failed = true
            this.errorMsg =
              'There seems to be an issue, please contact system admin for further assitance.'
          }
        })
    },
  },
}
</script>
<style>
.blank {
  border: 1px solid red !important;
}

.blank:focus {
  color: #495057;
  background-color: #fff;
  border-color: #ff8080;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.25);
}

.social-login-logo svg {
  margin: 10px;
  cursor: pointer;
}

.logo {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue